export { default } from '@material-ui/core/ListItemText';
